import { Stack, Typography, Box } from '@mui/material';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import { useAppSelector, useAppDispatch } from 'hooks/redux.hooks';
import { pagesEnum } from 'constants/ui.constants';

import { BasicCard } from 'components/BasicCard';
import { CenteredContent } from 'theme/elements/Content';
import { setToken } from 'state/reducers/auth.reducers';
import { ErrorText } from 'components/ErrorText';
import { selectTranslations } from 'state/reducers/translation.reducers';

export const Authorization = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const t = useAppSelector(selectTranslations);

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const token = queryParams.get('token');
		if (token && isPermitted(token)) {
			dispatch(setToken(token));
			navigate('/');
		}
	}, [location.search]);

	const isPermitted = (token: string): boolean => {
		const decodedToken: any = jwtDecode(token);
		return decodedToken?.groups?.length > 0;
	};

	return (
		<CenteredContent>
			<Stack
				direction="column"
				spacing={2}
				sx={{
					backgroundImage: 'url(/images/login-background.svg)',
					backgroundRepeat: 'no-repeat',
					backgroundPosition: 'center',
					width: '100%',
					height: '100%',
				}}
			>
				<BasicCard
					styleObj={{
						margin: 0,
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
						zIndex: 100,
						width: { xs: '100%', sm: 'auto' },
						height: { xs: '100%', sm: 'auto' },
						bgcolor: 'background.paper',
					}}
				>
					<Stack spacing={3}>
						<Stack spacing={2}>
							<Stack spacing={20} direction="column" sx={{ width: '100%' }}>
								<Stack spacing={3} direction="column" sx={{ width: '100%' }}>
									<Box>
										<img src={'/icons/brand-logo-color.webp'} />
									</Box>
									<Typography variant="pageTitle">{t('login.title')}</Typography>
								</Stack>
								<ErrorText error={t('login.not_permitted')} />
							</Stack>
						</Stack>
					</Stack>
				</BasicCard>
			</Stack>
		</CenteredContent>
	);
};
